// extracted by mini-css-extract-plugin
module.exports = {"text":"_3TUKv","hardcodedExample":"wrFKO"};